var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 4V8H30V6C30 4.89375 29.1063 4 28 4H10ZM8 4H4C2.89375 4 2 4.89375 2 6V8H8V4ZM2 10V26C2 27.1063 2.89375 28 4 28H28C29.1063 28 30 27.1063 30 26V10H9H2ZM0 6C0 3.79375 1.79375 2 4 2H28C30.2062 2 32 3.79375 32 6V26C32 28.2062 30.2062 30 28 30H4C1.79375 30 0 28.2062 0 26V6Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/Step_4.1fcb1bbf18c11556977bfaee8d1d3e05.svg";
export { ForwardRef as ReactComponent };